module.exports = __webpack_public_path__ + "img/geofisica_4-3_2048.e4b359a4.jpg";